import React from 'react'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import PageHeader from 'components/PartnershipsSite/PageHeader'

import { usePageView } from 'hooks'
import { getStaticWrapper, THEME } from 'utils'
import SecondaryFlex from 'components/PartnershipsSite/SecondaryGrid'

const SponsorshipIndex = () => {
  usePageView()

  const data = [
    {
      title: 'Premium Integration',
      description:
        'Integrate your brand with host endorsements from Barstool’s wide range of personalities & programming across audio, video, and social',
      image: 'https://chumley.barstoolsports.com/union/2021/05/19/Frame-1.1c063763.png',
      link: '/partnerships/sponsorships/premium-integration'
    },
    {
      title: 'Branded Social',
      description: "The world's largest and most engaging social media network for brands to connect with consumers",
      image:
        'https://chumley.barstoolsports.com/union/2021/02/02/phones.21b9c8a8.png?crop=0.77%2C0.77%2Cx0.23%2Cy0.23%2Csafe&format=png',
      link: '/partnerships/sponsorships/branded-social'
    },
    {
      title: 'Audience Targeting',
      description: 'Video and Display opportunities to surround our large library of original content',
      image:
        'https://chumley.barstoolsports.com/union/2021/02/02/devices.2e5ab84d.png?crop=0.84%2C0.74%2Cx0.13%2Cy0.18%2Csafe&format=png',
      link: '/partnerships/sponsorships/audience-targeting'
    },
    {
      title: 'Experiential',
      description: 'Bringing Barstool Sports and our partners to life for our fans',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/barstool_classic.d27fffbb.png',
      link: '/partnerships/sponsorships/experiential'
    },
    {
      title: 'Barstool Creative Services',
      description:
        "Utilize Barstool's Creative Services team to tap into design, experiential, and create custom assets with Barstool talent",
      image:
        'https://chumley.barstoolsports.com/union/2021/06/18/NAV_Spots.337c84d0.png?crop=0.95%2C0.88%2Cx0.02%2Cy0.06%2Csafe&format=png',
      link: '/partnerships/sponsorships/creative-services'
    },
    {
      title: 'Commerce & Licensing',
      description: 'The rights to produced content, image and likeness of our talent, and Barstool IP',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/mobile_screen_logo.63de32ba.png',
      link: '/partnerships/sponsorships/commerce'
    }
  ]

  return (
    <PartnershipsLayout background='#D8D8D8'>
      <div className='sponsorshipIndex'>
        <PageHeader title={'SPONSORSHIP OPPORTUNITIES'} details={'Our partners can be with us everywhere'} />
        <div className='sponsorshipIndex__top'>
          <h1>Cross-platform content with creative, authentic ad integrations across audio, video, and social</h1>
        </div>
        <SecondaryFlex items={data} />
      </div>
      <style jsx>{`
        .sponsorshipIndex {
          height: 100%;
          width: 100%;
          margin: 0 auto;
          background-color: #f5f5f5;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;
        }
        .sponsorshipIndex__top {
          width: 100%;
          padding: 4%;
          margin: 10px auto 0;
          background-color: #111828;
        }
        .sponsorshipIndex__top h1 {
          color: #fff;
          width: 95%;
          font-size: 1rem;
          line-height: 1.25;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .sponsorshipIndex__top {
            margin: 0 auto;
            padding: 6% 4%;
          }
          .sponsorshipIndex__top h1 {
            font-size: 0.95rem;
            line-height: 1.25;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .sponsorshipIndex__top {
            width: 100%;
            padding: 6% 4%;
          }
          .sponsorshipIndex__top h1 {
            font-size: 1.15rem;
            width: 90%;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .sponsorshipIndex__top h1 {
            font-size: 1.4rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
          .sponsorshipIndex__top h1 {
            font-size: 1.5rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .sponsorshipIndex__top h1 {
            font-size: 1.75rem;
          }
        }
      `}</style>
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default SponsorshipIndex
